import { useQuery } from '@tanstack/react-query'

import { useAllowPickupOrderFeature } from '@/hooks/useAllowPickupOrderFeature'

import { QUERY_KEYS } from '../../../lib/queryKeys'
import { getUserPickupOrders } from '../../user-package/userPkgService'

export const useUserPickupOrders = () => {
  const allowPickupOrderFeature = useAllowPickupOrderFeature()
  return useQuery({
    queryKey: [QUERY_KEYS.USER_PICKUP_ORDERS],
    queryFn: () => getUserPickupOrders(),
    enabled: allowPickupOrderFeature,
  })
}
